import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';

export const useImageGalleryColorDialogTracking = () => {
  const dispatch = useTracking();

  const trackColorPickerClick = () =>
    dispatch({
      event: 'ga_event',
      eventAction: 'rainbowpicker',
      eventCategory: 'userInteraction',
      eventLabel: 'rainbowpicker',
      eventValue: 'open',
    });

  const trackDialogClose = () =>
    dispatch({
      event: 'ga_event',
      eventAction: 'rainbowpicker',
      eventCategory: 'userInteraction',
      eventLabel: 'rainbowpicker',
      eventValue: 'close',
    });

  const trackVariationSelected = () =>
    dispatch({
      event: 'ga_event',
      eventAction: 'rainbowpicker',
      eventCategory: 'userInteraction',
      eventLabel: 'rainbowpicker',
      eventValue: 'variationChange',
    });

  return { trackColorPickerClick, trackDialogClose, trackVariationSelected };
};
